module.exports = __webpack_public_path__ + "img/xhs_bg_bt.753cd32b.png";